import { render, staticRenderFns } from "./FoldDrawer.vue?vue&type=template&id=55418de4&scoped=true"
import script from "./FoldDrawer.vue?vue&type=script&lang=js"
export * from "./FoldDrawer.vue?vue&type=script&lang=js"
import style0 from "./FoldDrawer.vue?vue&type=style&index=0&id=55418de4&prod&lang=less&scoped=true"
import style1 from "./FoldDrawer.vue?vue&type=style&index=1&id=55418de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55418de4",
  null
  
)

export default component.exports